/**
 * checkoutAdressForms
 *
 * Description
 */

import * as formValidate from "@sharedJS/formValidate";
import * as loader from "@shopJS/loader";
import * as renderTemplate from "@sharedJS/renderTemplate";
import * as rest from "@sharedJS/rest";
import * as dateMaskField from "@sharedJS/dateMaskField";
import pushDataLayer from "@ocm/services/dataLayer.js";
import * as loginReauthentication from "@Domains/js/shop/10-login-component/loginReauthentication";

// DOM
let $billingAdressForm;
let $shipmentAdressForm;
let $packstationAdressForm;
let $isoCodeSelect;
let $postCodeInput;
let $switchAddress;
let $switchPackstation;
let $closeSuggestedAddress;
let $closeSuggestedInvalidAddress;
let declinedSuggestedAddress;
let acceptedSuggestedAddress;
let oneAddressSuggestionForm;

// Templates
let confirmTemplate;
let confirmInvalidTemplate;

// Settings
let waitingForResponse;

let formAddress;

function init() {
	// DOM
	$billingAdressForm = $("#billing_address");
	$shipmentAdressForm = $("#shipment_address");
	$packstationAdressForm = $("#packstation_address");

	// Template
	confirmTemplate = $("#confirmAddressPopupTemplate");
	confirmInvalidTemplate = $("#confirmInvalidAddressPopupTemplate");

	// Settings
	waitingForResponse = false;

	$isoCodeSelect = $("#countryIso");
	$postCodeInput = $("#zipcode");

	$switchAddress = $(".js-form-switch-address");
	$switchPackstation = $(".js-form-switch-packstation");

	// Tracking
	$closeSuggestedAddress = $("#js-modal-checkout-address-confirm");
	$closeSuggestedInvalidAddress = $("#js-modal-checkout-address-invalid");

	declinedSuggestedAddress = "#js-declined-suggested-address";
	acceptedSuggestedAddress = "#js-accepted-suggested-address";

	// one-address-form option
	oneAddressSuggestionForm = "#js-one-address-suggestion-form";

	dateMaskField.init();
	inputChange();

	// Billing Address
	if ($billingAdressForm.length) {
		$billingAdressForm.attr("novalidate", "novalidate");
		$billingAdressForm.on(
			"submit",
			null,
			{ callback: submitForm, errorCallback: pushSubmitDataLayer },
			formValidate.validateFormOnSubmit
		);
		$billingAdressForm.on(
			"change",
			"input, select",
			{ errorCallback: pushChangeDataLayer },
			formValidate.validateElementOnChange
		);
		setCountryValidation();
	}

	// Shipment Address
	if ($shipmentAdressForm.length) {
		$shipmentAdressForm.attr("novalidate", "novalidate");
		$shipmentAdressForm.on(
			"submit",
			null,
			{ callback: submitForm, errorCallback: pushSubmitDataLayer },
			formValidate.validateFormOnSubmit
		);
		$shipmentAdressForm.on(
			"change",
			"input, select",
			{ errorCallback: pushChangeDataLayer },
			formValidate.validateElementOnChange
		);
		setCountryValidation();
	}

	// Packstation Address
	if ($packstationAdressForm.length) {
		$packstationAdressForm.attr("novalidate", "novalidate");
		$packstationAdressForm.on(
			"submit",
			null,
			{ callback: submitForm, errorCallback: pushSubmitDataLayer },
			formValidate.validateFormOnSubmit
		);
		$packstationAdressForm.on(
			"change",
			"input, select",
			{ errorCallback: pushChangeDataLayer },
			formValidate.validateElementOnChange
		);
		setCountryValidation();
	}

	// DeliverAdress Toggle
	$switchAddress.on("click", { formID: "shipment_address" }, _toggleDeliverAddressForm);
	$switchPackstation.on("click", { formID: "packstation_address" }, _toggleDeliverAddressForm);
	$switchAddress.css({ cursor: "pointer" });
	$switchPackstation.css({ cursor: "pointer" });

	//tracking
	//must be that generic, otherwise forms are not accessible
	$(document).on("submit", acceptedSuggestedAddress, () => _trackAcceptedSuggestedAddress());
	$(document).on("submit", declinedSuggestedAddress, () => _trackDeclinedSuggestedAddress());

	//one address choice modal -> vorschlag verwenden
	$(document).on("submit", oneAddressSuggestionForm, () => _trackAcceptedSuggestedAddress());

	/* Modal Close Clicks */
	const isCloseIcon = (target) => {
		let closeIcon;
		let getUseFromSvg = target.children[0];
		if (getUseFromSvg) {
			if (getUseFromSvg.tagName === "svg") {
				getUseFromSvg = getUseFromSvg.children[0];
			}
			if (getUseFromSvg.tagName === "use") {
				closeIcon = getUseFromSvg.href.baseVal === "#icon-close";
			}
		}
		return closeIcon;
	};

	$closeSuggestedAddress.on("click", (e) => {
		if (e.target === $closeSuggestedAddress[0] || isCloseIcon(e.target)) {
			_trackDeclinedSuggestedAddress();
		}
	});

	$closeSuggestedInvalidAddress.on("click", (e) => {
		if (e.target === $closeSuggestedInvalidAddress[0] || isCloseIcon(e.target)) {
			_trackDeclinedSuggestedAddress();
		}

		//specific case "Eingabe ändern" Button
		if (e.target === $(".js-confirm-invalid-declined-address")[0]) {
			_trackDeclinedSuggestedAddress();
			$closeSuggestedInvalidAddress.removeClass("is-visible");
		}
	});
	/* Modal Close Clicks - END */

	// checkout-address bindings
	$(".js-checkout-address").each(function () {
		const $this = $(this);
		const addressId = $(this).attr("data-id");
		$this.find(".js-checkout-address-select").on("click", null, addressId, _addressSelect);
	});

	const $body = $("body");
	$body.on("click", ".js-checkout-back-btn", () => _trackBackToCartBtn());
}

function _addressSelect(event) {
	loginReauthentication.precheckSessionState();

	event.preventDefault();
	event.stopPropagation();

	const url = $(event.currentTarget).attr("data-select-url");

	const CSRFToken = $("form").find("input[name='CSRFToken']").val();

	const addressId = event.data;

	$.ajax({
		type: "POST",
		url,
		contentType: "application/json; charset=utf-8",
		dataType: "json",
		data: JSON.stringify({ CSRFToken, addressCode: addressId }),
	})
		.done((response) => {
			_handleResponse(response);
		})
		.fail((error) => {
			console.log(error);
		});
}

function _setPaymentOrDelivery() {
	const url = window.location.href;
	if (url.includes("payment-address")) {
		formAddress = "payment";
	} else if (url.includes("delivery-address")) {
		formAddress = "delivery";
	}
}

const pushSubmitDataLayer = (message, elementID) => {
	pushDataLayer({
		event: "GAevent",
		event_category: "error_msg_submit",
		event_action: elementID,
		event_label: message,
	});
};

const pushChangeDataLayer = (message, elementID) => {
	pushDataLayer({
		event: "GAevent",
		event_category: "error_msg_change",
		event_action: elementID,
		event_label: message,
	});
};

//eslint-disable-next-line
function submitForm(target, isValid) {
	loader.addLoader($("body"));

	let dateMaskValid = true;
	if ($("#js-birthdate").val() !== undefined) {
		dateMaskValid = dateMaskField.validate($("#js-birthdate").val());
		if (!dateMaskValid) {
			_showInfoError();
		} else {
			_hideInfoError();
		}
	}

	if (!isValid || !dateMaskValid) {
		loader.removeLoader();

		const $invalidInputs = $(".is-not-valid", target);
		// supposed every formElement is within a div (c-form-row), this works even when the element itself is display:none
		const offsetOfFirstError = $($invalidInputs[0]).parent().offset().top;

		const offsetToTop = 80;
		const myscrolltop = offsetOfFirstError - offsetToTop;

		const bodyScrollTop = $("body").scrollTop(); // Safari
		const htmlScrollTop = $("html").scrollTop();
		const pageScrolltop = bodyScrollTop >= htmlScrollTop ? bodyScrollTop : htmlScrollTop;

		if (pageScrolltop > myscrolltop) {
			$("body,html").animate(
				{
					scrollTop: myscrolltop,
				},
				"slow"
			);
		}

		return;
	}

	if (waitingForResponse === false) {
		_executeFormSubmit(target)
			.done((response) => {
				console.log("Done callback triggered");
				_handleResponse(response);
			})
			.always(() => {
				loader.removeLoader();
				waitingForResponse = false;
			})
			.fail(() => {
				console.log("_executeFormSubmit failed!");
			});

		waitingForResponse = true;
	}
}

function _executeFormSubmit(form) {
	const $form = $(form);
	const context = {
		form: $form,
		callback: _executeFormSubmit,
		callbackData: form,
		ignoreRedirect: true,
	};
	return rest.submitForm(context);
}

// eslint-disable-next-line complexity
function _handleResponse(response) {
	if (confirmTemplate.length === 0) {
		init();
	}

	const addressResponse = response.addressResponse;

	if (_shouldRedirect(response)) {
		window.location.href = response.redirectUrl;
		return;
	}

	const success = addressResponse.success;

	_setPaymentOrDelivery();

	switch (success) {
		case "ok":
			window.location.href = "/checkout/";
			break;
		case "confirm":
			_handleResponseConfirm(addressResponse);
			break;
		case "confirm-invalid":
			_handleResponseConfirmInvalid(addressResponse);
			break;
		case "notvalid":
			_handleResponseNotValid(addressResponse);
			break;
	}
}

const _shouldRedirect = (response) => response.addressResponse === undefined && response.httpStatus === 200;

function _handleResponseConfirm(addressResponse) {
	_trackCorrectionShown();
	const $addressPopup = $("#js-modal-checkout-address-confirm");
	const $contentArea = $addressPopup.find(".js-modal-body");
	$contentArea.html("");
	const data = { confirm: addressResponse };
	renderTemplate.render($contentArea, confirmTemplate, data);
	document.querySelector("#js-modal-checkout-address-confirm").classList.add("is-visible");
}

function _handleResponseConfirmInvalid(addressResponse) {
	_trackCorrectionShown();
	const $addressPopup = $("#js-modal-checkout-address-invalid");
	const $contentArea = $addressPopup.find(".js-modal-body");
	$contentArea.html("");
	const data = { confirm: addressResponse };
	renderTemplate.render($contentArea, confirmInvalidTemplate, data);
	document.querySelector("#js-modal-checkout-address-invalid").classList.add("is-visible");
}

function _handleResponseNotValid(addressResponse) {
	_trackCorrectionShown();

	const $addressDiv = $("#js-modal-address-error-messages");

	const errorMessage = ocm.error_messages || {};
	$addressDiv.find("#addressErrorContainer").html("");

	if (addressResponse.is_selection === "true") {
		$addressDiv.find("#addressErrorSubHeadlineContainer").html(errorMessage.invalidAddressSubHeadlineBySelection);
	} else {
		$addressDiv.find("#addressErrorSubHeadlineContainer").html(errorMessage.invalidAddressSubHeadline);

		if (addressResponse.is_packstation === "true") {
			_appendAddressErrorContainer(addressResponse.valid_streetnr, errorMessage.invalidPackstationNr);
			_appendAddressErrorContainer(addressResponse.valid_plz, errorMessage.invalidPackstationPlz);
			_appendAddressErrorContainer(addressResponse.valid_city, errorMessage.invalidPackstationCity);
		} else {
			_appendAddressErrorContainer(addressResponse.valid_streetnr, errorMessage.invalidStreetNr);
			_appendAddressErrorContainer(addressResponse.valid_plz, errorMessage.invalidPlz);
			_appendAddressErrorContainer(addressResponse.valid_city, errorMessage.invalidCity);
			_appendAddressErrorContainer(addressResponse.valid_street, errorMessage.invalidStreet);
		}
	}

	_appendAddressErrorContainer(
		addressResponse.valid_packstation_as_payment_address,
		errorMessage.invalidPackstationAsPaymentAddress
	);

	document.querySelector("#js-modal-address-error-messages").classList.add("is-visible");
	_trackInvalidAddress(addressResponse.redirectUrl);
}

function _appendAddressErrorContainer(responseValue, errorMessage) {
	const error_prefix = '<p class="[ c-popup-message-error u-error-text ]">';
	const error_suffix = "</p>";
	const $addressErrorContainer = $("#addressErrorContainer");
	if (responseValue === "false") {
		$addressErrorContainer.append(error_prefix + errorMessage + error_suffix);
	}
}

function setCountryValidation() {
	// todo: mit Dino klären, ob die Country Validierung (das Pattern) schon vom Backend richtig kommt
	// https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation
	if (!$isoCodeSelect.length || !$postCodeInput.length) {
		return;
	}
	const isoCode = $isoCodeSelect.val().toUpperCase();
	if (isoCode === "DE") {
		_addNfieldsLongPostCodePattern($postCodeInput, 5);
	} else if (isoCode === "AT") {
		_addNfieldsLongPostCodePattern($postCodeInput, 4);
	} else if (isoCode === "CH") {
		_addNfieldsLongPostCodePattern($postCodeInput, 4);
	}
}

function _addNfieldsLongPostCodePattern(el, fieldLength) {
	el.attr("pattern", `[0-9]{${fieldLength}}`);
	el.attr("maxlength", fieldLength);
	el.blur();
}

// todo: duplicate code in accountProfile.js
//is input change
function inputChange() {
	if ($("#js-birthdate").length && $("#js-birthdate").val() === "") {
		$("#js-birthdate").addClass("u-type-date");
	}

	$("input#js-birthdate").change(() => {
		$("#js-birthdate").removeClass("u-type-date");
	});
}

// todo: duplicate code in accountProfile.js
function _showInfoError() {
	if ($(".js-birthday-error").hasClass("is-hidden")) {
		$(".js-birthday-error").removeClass("is-hidden");
	}
}

// todo: duplicate code in accountProfile.js
function _hideInfoError() {
	if (!$(".js-birthday-error").hasClass("is-hidden")) {
		$(".js-birthday-error").addClass("is-hidden");
	}
}

function _toggleDeliverAddressForm(event) {
	const formID = event.data.formID;

	if (formID === "shipment_address") {
		console.log(formID);
		$shipmentAdressForm.removeClass("u-hide");
		$packstationAdressForm.addClass("u-hide");

		$switchAddress.addClass("is-selected");
		$switchPackstation.removeClass("is-selected");
	} else if (formID === "packstation_address") {
		console.log(formID);
		$packstationAdressForm.removeClass("u-hide");
		$shipmentAdressForm.addClass("u-hide");

		$switchPackstation.addClass("is-selected");
		$switchAddress.removeClass("is-selected");
	}
}

/* Tracking */
function _trackCorrectionShown() {
	const event_action = `${formAddress}_address_correction_shown`;
	pushDataLayer({
		event: "GAevent",
		event_category: "address_check",
		event_action,
	});
}

function _trackDeclinedSuggestedAddress() {
	const event_label = "declined";
	_trackDecisionAddress(event_label);
}

function _trackAcceptedSuggestedAddress() {
	const event_label = "accepted";
	_trackDecisionAddress(event_label);
}

function _trackDecisionAddress(event_label) {
	const event_action = `${formAddress}_address_correction_decision`;
	pushDataLayer({
		event: "GAevent",
		event_category: "address_check",
		event_action,
		event_label,
	});
}

function _trackInvalidAddress() {
	const event_action = `${formAddress}_address_validation_shown`;
	pushDataLayer({
		event: "GAevent",
		event_category: "address_check",
		event_action,
	});
}

function _trackBackToCartBtn() {
	const { pagePath } = window.recommendationData.Recommendation.pageData;
	const url = window.location.href;
	pushDataLayer({
		event: "GAevent",
		event_category: "S_checkout",
		event_action: url.includes("payment-address") ? "S_return_to_cart" : "S_step_back",
		event_label: `S_${pagePath}`,
	});
}

export { init };
